module.exports = __webpack_public_path__ + "assets/img/thumb-Logitech-VC-1-Article.2f6f15ba.webp";